import { c as _c } from "react/compiler-runtime";
import { Button, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import './FeedbackButtonV2.scss';
type FeedbackButtonV2Props = Readonly<{
  isError: boolean;
  onOpen: () => void;
}>;
export function FeedbackButtonV2(t0) {
  const $ = _c(12);
  const {
    isError,
    onOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      error: "Feedback is unavailable right now. Please try again later.",
      default: "Help us improve your PetSmart experience."
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const text = t1;
  let t2;
  if ($[1] !== isError) {
    t2 = cn("feedback-button-v2", {
      "feedback-button-v2--error": isError
    });
    $[1] = isError;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isError ? text.error : text.default;
  let t4;
  if ($[3] !== t3) {
    t4 = <TextPassage className="feedback-button-v2__text" size="lg">{t3}</TextPassage>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isError || $[6] !== onOpen) {
    t5 = <Button text="Give feedback" disabled={isError} onClick={onOpen} />;
    $[5] = isError;
    $[6] = onOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}